<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" id="navigatorOffcanvas">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title">{{ $t('views.sidebar.headline') }}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas"></button>
    </div>

    <div class="offcanvas-body">
      <div class="navigator-column">
        <template v-for="(item, index) in navigatorItems" :key="item.route">

          <div class="navigator-tile" @click="navigate(item.route)">

            <!-- Icon + Titel nebeneinander -->
            <div class="navigator-header">
              <svg class="navigator-icon" width="22" height="22"> <use :xlink:href="require('@/assets/icons/icons.svg') + '#' + item.icon"></use> </svg>
              <div class="fs-5 ms-2">{{ item.name }}</div>
            </div>

            <!-- Beschreibung darunter -->
            <div class="navigator-description fs-08">
              {{ item.description }}
            </div>

          </div>

          <!-- Pfeil down / Placeholder-->
          <div v-if="index < navigatorItems.length - 2" class="navigator-arrow">
            <svg width="24" height="24" viewBox="0 0 24 24"> <path d="M12 4v16m0 0l-6-6m6 6l6-6" stroke="#999" stroke-width="3" fill="none" stroke-linecap="round" stroke-linejoin="round" /> </svg>
          </div>
          <div v-else-if="index === 3" class="arrow-placeholder">
            <!-- <div class="fs-08 arrow-text">Überwacht den gesamten Prozess</div>-->
            <svg width="24" height="24" viewBox="0 0 24 24"> <path d="M4 15 L12 9 L20 15" stroke="#999" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" /> </svg>
          </div>

        </template>

      </div>
    </div>
  </div>
</template>

<script>
import * as bootstrap from 'bootstrap'

export default {
  name: 'VisualNavigation',

  data () {
    return {
      navigatorItems: [
        { name: this.$t('views.sidebar.vision'), icon: 'vision', route: '/strategies/manage/visions', description: this.$t('views.sidebar.visionText') },
        { name: this.$t('views.sidebar.strategies'), icon: 'strategy', route: '/strategies/manage/strategies', description: this.$t('views.sidebar.strategiesText') },
        { name: this.$t('views.sidebar.objectives'), icon: 'objective', route: '/objectives/manage/objectives', description: this.$t('views.sidebar.objectivesText') },
        { name: this.$t('views.sidebar.projects'), icon: 'project', route: '/projects/manage/projects', description: this.$t('views.sidebar.projectsText') },
        { name: this.$t('views.sidebar.monitoring'), icon: 'kpi', route: '/monitoring/kpis', description: this.$t('views.sidebar.monitoringText') }
      ]
    }
  },

  methods: {
    navigate (route) {
      this.$router.push(route)

      // Offcanvas schließen
      const offcanvasEl = document.getElementById('navigatorOffcanvas')
      const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasEl)
      offcanvas.hide()
    }
  }
}
</script>

<style scoped>
.navigator-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding-top: 10px;
}

.navigator-tile {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 10px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #e0e0e0;
}

.navigator-tile:hover {
  background: #e5ebf1;
  transform: translateY(-3px);
}

.navigator-icon {
  fill: #19396C;
}

.navigator-arrow {
  display: flex;
  justify-content: center;
  margin: 8px 0;
}

.navigator-header {
  display: flex;
  align-items: center;
  justify-content: center; /* zentriert Icon + Titel */
  gap: 8px;
}

.navigator-description {
  text-align: center;
  margin-top: 4px;
}

.arrow-placeholder {
  width: 100%;
  text-align: center;
  display: block;
}

.arrow-placeholder svg {
  display: block;
  margin: 0 auto;
}

.arrow-text {
  width: 100%;
  text-align: center;
  margin-top: 1px; /* optional */
}

</style>
